import { debug as debugGen } from "debug";
import Subscriber from "../Subscriber";
import config from "../../config";
import pageManager, { CachePage } from "../../page";

const debug = debugGen("vtTracker:StaySubscriber");

const REPORT_CHECK_INTERVAL = 1000;
const DEFAULT_MAX_INTERVAL = 10;
const DEFAULT_MAX_REPORT = 60 * 1000;

interface ReportCacheItem {
    count: number;
    time: number;
}

export default class Stay extends Subscriber {
    private delay = 0;

    private startTime = 0;

    private reportCache: Record<string, ReportCacheItem> = {};

    setup(): void {
        debug("stayReport flag: %s", config.stayReport);

        if (config.stayReport === false) {
            return;
        }

        this.startTime = Date.now();

        document.documentElement.addEventListener("vtPageStay", (e: Event) => {
            this.emit("action", e);
        });

        this.report();
    }

    private nextTime(): number {
        return REPORT_CHECK_INTERVAL;
    }

    private report(): void {
        setTimeout(() => {
            if (config.stayReport === false) {
                return;
            }

            const pages = pageManager.getVisiblePages();

            debug("to report page stay pages %o", pages);

            const ids = pages.map((p: CachePage): string => {
                this.reportPage(p);

                return p.id;
            });

            // 缓存里不可见的page重置掉，有一种情况需要注意：
            // 如果某个页面隐藏之后快速恢复可见（间隔小于检查间隔），那会认为是连续可见
            Object.keys(this.reportCache).forEach(id => {
                if (!ids.includes(id)) {
                    this.reportCache[id] = null;
                }
            });

            this.report();
        }, this.nextTime());
    }

    private reportPage(page: CachePage): void {
        const info: ReportCacheItem = {
            count: 0,
            time: 0,
            ...this.reportCache[page.id]
        };

        const maxReport =
            parseInt(page.moreInfo["stayduration"], 10) || DEFAULT_MAX_REPORT;

        const now = Date.now();

        // 页面单次最多上报停留时长
        if (now - page.lastVisibleTime > maxReport) {
            return;
        }

        // 上报间隔检查
        if (
            now - info.time <
            Math.min(2 ** info.count, DEFAULT_MAX_INTERVAL) * 1000
        ) {
            return;
        }

        page.node.dispatchEvent(new Event("vtPageStay", { bubbles: true }));

        info.count += 1;
        info.time = now;

        this.reportCache[page.id] = info;
    }
}
